import axios from 'axios';

// const baseUrl = 'https://server.farmingwindow.com/orange_large_screen/'
const baseUrl = 'https://www.nanfengmj.com/orange_large_screen/'
const http = axios.create({
    baseURL: baseUrl, // API 基础路径
    timeout: 5000 // 请求超时时间
});
export default http

